export default "__VITE_ASSET__DXoxe59p__"